<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="1200px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class=" font-weight-bold text-capitalize ml-5 mr-5" color="primary"> <v-icon class="me-1" small>mdi-plus</v-icon> P/C Pricing </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">P/C Pricing</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <v-form @submit="createFaq()" v-model="valid" ref="form">
              <v-data-table :headers="headers" :items="dataList" class="elevation-1 mt-2" :mobile-breakpoint="0" :loading="loading">
                <template v-slot:[`item.noOfDays`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">{{ item.noOfDays }}</div>
                </template>

                <template v-slot:[`item.protien50`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.protien50"></v-text-field>
                  </div>
                </template>

                <template v-slot:[`item.carb50`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.carb50"></v-text-field>
                  </div>
                </template>

                <template v-slot:[`item.protien100`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.protien100"></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.carb100`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.carb100"></v-text-field>
                  </div>
                </template>

                <template v-slot:[`item.protien150`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.protien150"></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.carb150`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.carb150"></v-text-field>
                  </div>
                </template>

                <template v-slot:[`item.protien200`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.protien200"></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.carb200`]="{ item }">
                  <div class="d-flex justify-center align-center mt-4">
                    <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.carb200"></v-text-field>
                  </div>
                </template>
              </v-data-table>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="mt-n8 justify-end">
          <v-btn
            color="primary"
            class="dark--text mb-2 mb-sm-4 text-capitalize"
            :width="$vuetify.breakpoint.smAndUp ? 120 : 90"
            @click="createProductCategory"
            :loading="btnloading"
            :disabled="!valid"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidatorNumber } from "../../core/methods/validations";

export default {
  components: {},
  apollo: {
    getAppConfigurations() {
      return {
        query: require("@/accounts/api/getAppConfigurationsPC.graphql"),
        result({ data }) {
          let savedData = data.getAppConfigurations.pcValuePricing;
          if (savedData) this.savedData = savedData;
          this.initPage();
        },
      };
    },
  },
  data() {
    return {
      requiredValidatorNumber,
      show_dialog_box: false,
      loading: false,
      snackbar: false,
      btnloading: false,
      text: "Data saved successfully",
      valid: true,
      errors: [],
      dataList: [],
      allCategories: [],
      savedData: [],
      headers: [
        { text: "No Of Days", value: "noOfDays", width: 50 },
        { text: "P50", value: "protien50", width: 100 },
        // { text: "C50", value: "carb50", width: 100 },
        { text: "P100", value: "protien100", width: 100 },
        // { text: "C100", value: "carb100", width: 100 },
        { text: "P150", value: "protien150", width: 100 },
        // { text: "C150", value: "carb150", width: 100 },
        { text: "P200", value: "protien200", width: 100 },
        // { text: "C200", value: "carb200", width: 100 },
      ],
    };
  },
  methods: {
    initPage() {
      this.dataList = [];
      let data = {
        noOfDays: 1,
        protien50: this.savedData[0]?.protien50 || 0,
        carb50: this.savedData[0]?.carb50 || 0,
        protien100: this.savedData[0]?.protien100 || 0,
        carb100: this.savedData[0]?.carb100 || 0,
        protien150: this.savedData[0]?.protien150 || 0,
        carb150: this.savedData[0]?.carb150 || 0,
        protien200: this.savedData[0]?.protien200 || 0,
        carb200: this.savedData[0]?.carb200 || 0,
      };
      this.dataList.push(data);

      data = {
        noOfDays: 6,
        protien50: this.savedData[1]?.protien50 || 0,
        carb50: this.savedData[1]?.carb50 || 0,
        protien100: this.savedData[1]?.protien100 || 0,
        carb100: this.savedData[1]?.carb100 || 0,
        protien150: this.savedData[1]?.protien150 || 0,
        carb150: this.savedData[1]?.carb150 || 0,
        protien200: this.savedData[1]?.protien200 || 0,
        carb200: this.savedData[1]?.carb200 || 0,
      };
      this.dataList.push(data);

      data = {
        noOfDays: 12,
        protien50: this.savedData[2]?.protien50 || 0,
        carb50: this.savedData[2]?.carb50 || 0,
        protien100: this.savedData[2]?.protien100 || 0,
        carb100: this.savedData[2]?.carb100 || 0,
        protien150: this.savedData[2]?.protien150 || 0,
        carb150: this.savedData[2]?.carb150 || 0,
        protien200: this.savedData[2]?.protien200 || 0,
        carb200: this.savedData[2]?.carb200 || 0,
      };
      this.dataList.push(data);

      data = {
        noOfDays: 20,
        protien50: this.savedData[3]?.protien50 || 0,
        carb50: this.savedData[3]?.carb50 || 0,
        protien100: this.savedData[3]?.protien100 || 0,
        carb100: this.savedData[3]?.carb100 || 0,
        protien150: this.savedData[3]?.protien150 || 0,
        carb150: this.savedData[3]?.carb150 || 0,
        protien200: this.savedData[3]?.protien200 || 0,
        carb200: this.savedData[3]?.carb200 || 0,
      };
      this.dataList.push(data);

      data = {
        noOfDays: 26,
        protien50: this.savedData[4]?.protien50 || 0,
        carb50: this.savedData[4]?.carb50 || 0,
        protien100: this.savedData[4]?.protien100 || 0,
        carb100: this.savedData[4]?.carb100 || 0,
        protien150: this.savedData[4]?.protien150 || 0,
        carb150: this.savedData[4]?.carb150 || 0,
        protien200: this.savedData[4]?.protien200 || 0,
        carb200: this.savedData[4]?.carb200 || 0,
      };
      this.dataList.push(data);
    },
    close() {
      this.show_dialog_box = false;
    },
    createProductCategory() {
      this.btnloading = true;
      let dataList = JSON.parse(JSON.stringify(this.dataList));
      dataList.forEach(element => {
        element.protien50 = parseFloat(element.protien50);
        element.carb50 = parseFloat(element.carb50);
        element.protien100 = parseFloat(element.protien100);
        element.carb100 = parseFloat(element.carb100);
        element.protien150 = parseFloat(element.protien150);
        element.carb150 = parseFloat(element.carb150);
        element.protien200 = parseFloat(element.protien200);
        element.carb200 = parseFloat(element.carb200);
      });

      this.$apollo
        .mutate({
          mutation: require("@/accounts/api/updateConfigurationsPC.graphql"),
          variables: {
            pcValuePricing: dataList,
          },
        })
        .then(data => {
          console.log(data);
          this.btnloading = false;
          this.show_dialog_box = false;
          this.snackbar = true;
        })

        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
          this.show_dialog_box = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
